import { Box } from '@mui/material';
import { isUndefined } from 'lodash';
import {
  ListButton,
  Show,
  Tab,
  TabbedShowLayout,
  TabbedShowLayoutTabs,
  TopToolbar,
  useRecordContext,
  useShowController,
} from 'react-admin';
import { BackButton } from 'src/lib';
import { Account } from 'src/models';

import { AccountHolderShow } from './AccountHolder/AccountHolderShow';
import { AccountInformationShow } from './AccountInformation/AccountInformationShow';
import { ApplicationShow } from './Application/ApplicationShow';
import { HistoryShow } from './History/HistoryShow';
import { InvestigationShow } from './Investigation/InvestigationShow';
import { SuitabilityInformationShow } from './SuitabilityInformation/SuitabilityInformationShow';
import { SummaryShow } from './Summary/SummaryShow';
import { SyncAccountButton } from './SyncAccountButton';
import { TrustedContactShow } from './TrustedContact/TrustedContactShow';
import { UpdateRequestsShow } from './UpdateRequests/UpdateRequestsShow';

const Title = () => {
  const record = useRecordContext<Account>();

  return (
    <span>
      Account: <strong>{record.id}</strong>
      {record.accountId && `, ${record.accountId}`}
      {`, ${record.type.label}`}
    </span>
  );
};

const Actions = () => {
  return (
    <TopToolbar>
      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <BackButton fallback='Accounts' />
        </Box>
        <Box>
          <SyncAccountButton />
          <ListButton />
        </Box>
      </Box>
    </TopToolbar>
  );
};

export const AccountShow = () => {
  const { record } = useShowController<Account>();

  return (
    <Show emptyWhileLoading title={<Title />} actions={<Actions />}>
      <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant='scrollable' />}>
        <Tab label='Account' sx={{ overflow: 'auto' }}>
          <AccountInformationShow />
        </Tab>
        {record?.type.isEntity && (
          <Tab label='Application'>
            <ApplicationShow />
          </Tab>
        )}
        {record?.accountId && (
          <Tab label='Investigations'>
            <InvestigationShow />
          </Tab>
        )}
        <Tab label='Account Holder/s'>
          <AccountHolderShow />
        </Tab>
        {(record?.primaryAccountHolder?.trustedContact ||
          (record?.jointAccountType?.isTenantsInCommon &&
            !isUndefined(record.primaryAccountHolder?.jointTenantsInCommonInterestPercent))) && (
          <Tab label='Users/Trusted Contact'>
            <TrustedContactShow />
          </Tab>
        )}
        {record?.suitabilityInformation && (
          <Tab label='Financial/Suitability'>
            <SuitabilityInformationShow />
          </Tab>
        )}
        {record?.accountId && (
          <Tab label='Summary'>
            <SummaryShow accountId={record.accountId} />
          </Tab>
        )}
        {record?.accountId && (
          <Tab label='History'>
            <HistoryShow accountId={record?.accountId} accountNumber={record?.accountNumber} />
          </Tab>
        )}
        {record?.accountId && (
          <Tab label='Update Requests'>
            <UpdateRequestsShow />
          </Tab>
        )}
      </TabbedShowLayout>
    </Show>
  );
};
